// hooks/useSpreadsheetAutoSave.js
import { useEffect, useRef, useCallback } from "react";

export const useSpreadsheetAutoSave = (univerAPI, billId, enabled = true) => {
  const saveTimeoutRef = useRef(null);
  const DEBOUNCE_MS = 2000; // Salva 2s após última alteração

  const saveDraft = useCallback(async () => {
    if (!univerAPI || !billId) return;

    try {
      const fWorkbook = univerAPI.getActiveWorkbook();
      if (!fWorkbook) return;

      const snapshot = fWorkbook.save();
      const draftKey = `bill_draft_${billId}`;

      localStorage.setItem(
        draftKey,
        JSON.stringify({
          snapshot,
          savedAt: new Date().toISOString(),
          billId,
        }),
      );

      console.log("✅ Rascunho salvo localmente");
    } catch (error) {
      console.error("❌ Erro ao salvar rascunho:", error);
    }
  }, [univerAPI, billId]);

  // Escuta mudanças na planilha
  useEffect(() => {
    if (!enabled || !univerAPI) return;

    const disposable = univerAPI.addEvent(
      univerAPI.Event.SheetValueChanged,
      () => {
        // Debounce: aguarda usuário parar de digitar
        if (saveTimeoutRef.current) {
          clearTimeout(saveTimeoutRef.current);
        }
        saveTimeoutRef.current = setTimeout(saveDraft, DEBOUNCE_MS);
      },
    );

    return () => {
      disposable.dispose();
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, [univerAPI, enabled, saveDraft]);

  // Carregar rascunho existente
  const loadDraft = useCallback(() => {
    if (!billId) return null;

    const draftKey = `bill_draft_${billId}`;
    const draftData = localStorage.getItem(draftKey);

    if (!draftData) return null;

    try {
      const parsed = JSON.parse(draftData);
      console.log("📄 Rascunho encontrado, salvo em:", parsed.savedAt);
      return parsed.snapshot;
    } catch (error) {
      console.error("❌ Erro ao carregar rascunho:", error);
      return null;
    }
  }, [billId]);

  // Limpar rascunho (após salvar no banco)
  const clearDraft = useCallback(() => {
    if (!billId) return;
    const draftKey = `bill_draft_${billId}`;
    localStorage.removeItem(draftKey);
    console.log("🗑️ Rascunho limpo");
  }, [billId]);

  return {
    saveDraft,
    loadDraft,
    clearDraft,
  };
};
